import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import ServerSelector from '../../components/ServerSelector'
import localize from '../../store/localize'
import strings from '../../components/ServerSelector/server-selector.json'
import { actionServersSetActiveServer } from '../../actions'

function mapStateToProps(state) {
    const { servers } = state
    const locale = selectors.getLanguage(state)
    return {
        localize: value => localize(strings, locale, value),
        activeServer: servers.active,
        servers: servers.list,
        testServers: selectors.getTestServers(state),
        language: locale,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setActiveServer: (name) => {
            dispatch(actionServersSetActiveServer(name))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServerSelector)



// WEBPACK FOOTER //
// ./src/containers/ServerSelector/server-selector.js